import { Field } from '@datx/core';
import { JsonApiModel } from '../../core/jsonApi/jsonApiModel';

export class ExplanationContentJsonModel extends JsonApiModel {
  public static override readonly type = 'explanation-contents';

  @Field({ isIdentifier: true })
  public id!: string;

  @Field()
  name!: string;

  @Field()
  content!: string;
}
